import {useContext} from 'react'

import {useDecisionCallback} from '@s-ui/pde'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {ROUTES} from '../../../../../../config/index.js'

export const useNavigationReservationPayment = () => {
  const {push} = useRouter()
  const {track} = useAnalyticsTrack()
  const {domain} = useContext(Context)
  const {decide} = useDecisionCallback()

  const navigation = async interactionUrl => {
    const {searchParams} = new URL(interactionUrl)
    const adId = searchParams.get('adId')

    track({
      event: 'Reservation Start Clicked',
      data: {hit_origin: 'system message', products: [{id: adId, category: 'ads', price: 0, quantity: 0}]}
    })

    const config = domain.get('config')
    const {RESERVATION_STATUSES} = config.get('financing')
    const {AD_DETAIL_RESERVATION_HASHES: RESERVATION_HASHES} = config.get('page')

    const [[adDetailsError, adDetailsResponse], [reservationStatusError, reservationStatusResponse]] =
      await Promise.all([
        domain.get('get_ad_details_ads_use_case').execute({adId}),
        domain.get('get_ad_reservation_status_transactions_use_case').execute({adId})
      ])

    const adUrl = adDetailsError ? null : adDetailsResponse?.ad?.url
    const isReservable =
      !reservationStatusError && reservationStatusResponse?.adReservationStatus === RESERVATION_STATUSES.RESERVABLE

    const {enabled: isReservationFlowRevamp} = decide('ff_web_transaction_revamp_reservation_flow', {
      attributes: {isAdReservable: isReservable}
    })

    if (isReservationFlowRevamp && adUrl) {
      push({pathname: adUrl, hash: RESERVATION_HASHES.OPEN_DRAWER})
      return
    }

    push(`${ROUTES.RESERVATION.PAYMENT}?adId=${adId}`)
  }

  return navigation
}
